import { render, staticRenderFns } from "./ComplieFreeNodeMenu.vue?vue&type=template&id=b67a281c&scoped=true"
import script from "./ComplieFreeNodeMenu.vue?vue&type=script&lang=js"
export * from "./ComplieFreeNodeMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieFreeNodeMenu.vue?vue&type=style&index=0&id=b67a281c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67a281c",
  null
  
)

export default component.exports